import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mHead"
  }, [_c('div', {
    staticClass: "mHead-main"
  }, [_c('div', {
    staticClass: "mHead-avatar"
  }, [_c('div', {
    staticClass: "mHead-avatar-img"
  }, [_vm.userInfo.avatar ? _c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }) : _c('m-head-img', {
    attrs: {
      "name": _vm.userInfo,
      "bgColor": _vm.userInfo.head_color
    }
  })], 1), _c('div', {
    staticClass: "mHead-avatar-info"
  }, [_c('div', {
    staticClass: "mHead-avatar__title"
  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))]), _c('div', {
    staticClass: "mHead-avatar__balance"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.userInfo.coin)))]), _c('span', [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.userInfo.stars)))])])])]), _c('div', {
    staticClass: "mHead-btns"
  }, [_c('div', {
    staticClass: "btn-num"
  }, [_c('div', {
    staticClass: "icon",
    domProps: {
      "innerHTML": _vm._s(_vm.svg_tickets)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.ticket)))])]), _c('div', {
    staticClass: "btn-tickets",
    on: {
      "click": _vm.showPop
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-add"
    }
  })], 1), _c('span', [_vm._v("Tickets")])])]), _c('pop-prompt', {
    attrs: {
      "location": "bottom",
      "show": _vm.popEarnTicketShow,
      "title": "How to Earn Tickets",
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popEarnTicketShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-earnticket"
  }, [_c('div', {
    staticClass: "pop-earnticket__img"
  }, [_c('img', {
    attrs: {
      "src": require('@images/pop-earn-ticket-img.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-earnticket-list"
  }, [_c('div', {
    staticClass: "pop-earnticket-item"
  }, [_c('div', {
    staticClass: "pop-earnticket-item__img"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-instantReward.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-earnticket-item-info"
  }, [_c('div', {
    staticClass: "pop-earnticket-item__title"
  }, [_vm._v("Instant reward")]), _c('div', {
    staticClass: "pop-earnticket-item__info"
  }, [_vm._v("Earn tickets when prediction wins")]), _c('div', {
    staticClass: "pop-earnticket-item__sub"
  }, [_vm._v("Track your stash in the Profile")])])]), _c('div', {
    staticClass: "pop-earnticket-item"
  }, [_c('div', {
    staticClass: "pop-earnticket-item__img"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/pop-invitationReward.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-earnticket-item-info"
  }, [_c('div', {
    staticClass: "pop-earnticket-item__title"
  }, [_vm._v("Complete Quests & Invite Friends")]), _c('div', {
    staticClass: "pop-earnticket-item__info"
  }, [_vm._v("Get tickets for activities")]), _c('div', {
    staticClass: "pop-earnticket-item__sub"
  }, [_vm._v("Invite Friends and complete tasks")])])]), _c('div', {
    staticClass: "pop-earnticket-item"
  }, [_c('div', {
    staticClass: "pop-earnticket-item__img"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-buyTicket.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-earnticket-item-info"
  }, [_c('div', {
    staticClass: "pop-earnticket-item__title"
  }, [_vm._v("Buy Tickets with Stars")]), _c('div', {
    staticClass: "pop-earnticket-item__info"
  }, [_vm._v(_vm._s(_vm.settingInfo.ticket.stars) + " Stars = " + _vm._s(_vm.settingInfo.ticket.ticket) + " tickets")]), _c('div', {
    staticClass: "pop-earnticket-item__sub"
  }, [_vm._v("Buy easily via Telegram")])])])]), _c('div', {
    staticClass: "pop-earnticket-btns"
  }, [_c('div', {
    staticClass: "btn btn-earntickets",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/tasks');
      }
    }
  }, [_vm._v("Earn tickets")]), _c('div', {
    staticClass: "btn btn-buy",
    on: {
      "click": function ($event) {
        !_vm.isBuyTicketLoading && _vm.buyTicket();
      }
    }
  }, [!_vm.isBuyTicketLoading ? [_vm._v(" Buy with stars ")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popMoreSpinsClass",
      "show": _vm.popBuyTicketShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popBuyTicketShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-morespins"
  }, [_c('div', {
    staticClass: "pop-morespins__title"
  }, [_vm._v("Buy Tickets width Stars")]), _c('div', {
    staticClass: "pop-morespins-list"
  }, [_c('transition-group', {
    staticClass: "pop-morespins-scroll",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.ticketPriceList && !_vm.isBuyTicketListLoading ? _vm._l(_vm.ticketPriceList, function (item, index) {
    return _c('div', {
      key: `mp${index}`,
      staticClass: "pop-morespins-item off",
      class: [index == 1 && 'popular', index == _vm.ticketPriceList.length - 1 && 'best'],
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onPayTicket(item);
        }
      }
    }, [index == 1 || index == _vm.ticketPriceList.length - 1 ? _c('div', {
      staticClass: "pop-morespins-item-tag"
    }) : _vm._e(), _c('div', {
      staticClass: "pop-morespins-item-main"
    }, [_c('div', {
      staticClass: "pop-morespins-item__num"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v("x" + _vm._s(_vm.fmt_pre(item.ticket)))]), _c('div', {
      staticClass: "pop-morespins-item__sub"
    }, [item.off ? _c('span', [_vm._v(_vm._s(item.off))]) : _vm._e()]), _c('div', {
      staticClass: "pop-morespins-item-info"
    }, [_c('div', {
      staticClass: "pop-morespins-item-info__price"
    }, [!item.isLoading ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-star.png'),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(item.stars)))])] : [_c('div', {
      staticClass: "circleLoading"
    })]], 2)])])]);
  }) : _vm._e()], 2)], 1)])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };